import { cx } from './internal/cx'
import './WeekdaySelector.css'

export type WeekdaySelectorProps = {
  /** Selected weekday indexes: 0 = Sunday … 6 = Saturday. */
  value: number[]
  onChange: (value: number[]) => void
}

/** Week starts on Monday (Dutch convention); index maps to JS Date getDay(). */
const DAYS: { index: number; short: string; full: string }[] = [
  { index: 1, short: 'ma', full: 'maandag' },
  { index: 2, short: 'di', full: 'dinsdag' },
  { index: 3, short: 'wo', full: 'woensdag' },
  { index: 4, short: 'do', full: 'donderdag' },
  { index: 5, short: 'vr', full: 'vrijdag' },
  { index: 6, short: 'za', full: 'zaterdag' },
  { index: 0, short: 'zo', full: 'zondag' },
]

export function WeekdaySelector({ value, onChange }: WeekdaySelectorProps) {
  const toggle = (index: number) => {
    if (value.includes(index)) {
      onChange(value.filter((day) => day !== index))
    } else {
      onChange([...value, index].sort((a, b) => a - b))
    }
  }

  return (
    <div className="ui-weekdays" role="group" aria-label="Weekdagen">
      {DAYS.map((day) => {
        const selected = value.includes(day.index)
        return (
          <button
            key={day.index}
            type="button"
            className={cx('ui-weekdays__day', selected && 'ui-weekdays__day--selected')}
            aria-pressed={selected}
            aria-label={day.full}
            onClick={() => toggle(day.index)}
          >
            <span aria-hidden="true">{day.short}</span>
          </button>
        )
      })}
    </div>
  )
}
